module.exports = __webpack_public_path__ + "diagonal_2_lines_overlay-96ef820079eb310b3d7f745848f20380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/diagonal_2_lines_overlay.png
// module id = 1548
// module chunks = 1